<template>
  <aside class="border-r border-gray-200 overflow-y-auto">
    <div
      v-for="letter in Object.keys(groupedContacts)"
      :key="letter"
    >
      <div
        v-if="letter !== 'undefined'"
        class="sticky top-0 left-0 z-10 border-t border-b border-gray-200 bg-gray-50 py-1 text-sm font-medium text-gray-500"
      >
        <h3 class="pl-3">{{ letter }}</h3>
      </div>
      <ul
        v-if="letter !== 'undefined'"
        role="list"
        class="relative divide-y divide-gray-200"
      >
        <li
          v-for="contact in groupedContacts[letter]"
          :key="contact.id"
        >
          <ObuBookingsAddressBookListItem
            :contact="contact"
            @ab-select="emit('abSelected', contact.id)"
          />
        </li>
      </ul>
    </div>
  </aside>
</template>
<script setup>
import { useProp } from '@/composables/useProp.js'
import { computed, toRefs } from 'vue'

import ObuBookingsAddressBookListItem from './ObuBookingsAddressBookListItem.vue'

import { groupBy } from 'lodash'

const props = defineProps({
  contacts: useProp(Array)
})

const firstLetter = (contact) => {
  if (contact.company && !contact.last_name) {
    return contact.company.substr(0, 1).toUpperCase()
  }
  if (contact.last_name) {
    return contact.last_name.substr(0, 1).toUpperCase()
  }
}

const emit = defineEmits(['abSelected', 'abSearchChanges'])
const { contacts } = toRefs(props)

const groupedContacts = computed(() => groupBy(contacts.value, firstLetter))

</script>
